"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSIInclude = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var is_client_side_1 = require("./is_client_side");
var fetch_fallback_html_1 = require("./fetch_fallback_html");
var utils_1 = require("./utils");
var SSIInclude = function (props) {
    var initialContent = is_client_side_1.isClientSide() ? (utils_1.getInitialHtml(props.tagId) || '') : utils_1.getSSITag(props.url);
    var _a = tslib_1.__read(react_1.useState(initialContent), 2), content = _a[0], setContent = _a[1];
    react_1.useEffect(function () {
        if (is_client_side_1.isClientSide() && (content === utils_1.getSSITag(props.url) || content === '')) {
            fetch_fallback_html_1.fetchFallbackHtml(props.url)
                .then(function (response) {
                if (!response.ok) {
                    throw new Error("Failed to load " + props.url + ". Got status " + response.status + ".");
                }
                return response.text();
            })
                .then(function (data) {
                setContent(data);
                if (props.onClientSideFetch) {
                    var status_1 = {
                        type: 'warning',
                        message: 'Resolved content client-side.'
                    };
                    props.onClientSideFetch(null, status_1);
                }
            })
                .catch(function (err) {
                if (props.onClientSideFetch) {
                    var status_2 = {
                        type: 'error',
                        message: "Client-side fallback fetch failed." + (err ? " " + err : '')
                    };
                    props.onClientSideFetch(err, status_2);
                }
            });
        }
        if (is_client_side_1.isClientSide() && content !== utils_1.getSSITag(props.url) && content !== '') {
            utils_1.remountScripts(props.tagId);
        }
    }, [content]);
    if (!content) {
        return null;
    }
    return (react_1.default.createElement("div", { id: props.tagId, "data-testid": props.testId, dangerouslySetInnerHTML: {
            __html: content
        }, suppressHydrationWarning: true }));
};
exports.SSIInclude = SSIInclude;
